import { useNavigate } from "react-router-dom";
import { phaseStore } from '../store';
import '../css/pages/home.css';
import Button from '../components/button';
import logoTrivia from '../assets/imagenes/trivia.png';
import brand from '../assets/imagenes/marca.jpg';

const Home = () => {
  const { setPhase } = phaseStore();
  const navigate = useNavigate();

  const handleClick = ()=> {
    navigate("/ranking-general");
    setPhase(1);
  }

  return (
    <>
      <div className="container">
        <img src={logoTrivia} alt="logo_trivia" className="logo-trivia" />
        <div className="absolute-content">
          <h3>La trivia ha finalizado</h3>
          <Button text="Tabla de posiciones" handleClick={handleClick} />
        </div>
      </div>
    </>
    
  );
}

export default Home;